"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePassword = exports.addMember = exports.updateUserMeta = exports.getPresetAvatars = exports.getUserMeta = void 0;
const md5_1 = require("../utils/md5");
const base_1 = require("./base");
const const_1 = require("./const");
const getUserMeta = () => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.get)(const_1.BASE_PATH + "/users/me", true);
});
exports.getUserMeta = getUserMeta;
const getPresetAvatars = () => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.get)(const_1.BASE_PATH + "/users/get-preset-avatar-list", true);
});
exports.getPresetAvatars = getPresetAvatars;
const updateUserMeta = (userMeta) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/users/update-user-meta", userMeta, true);
});
exports.updateUserMeta = updateUserMeta;
const addMember = (member) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/users/add-member", member, true);
});
exports.addMember = addMember;
const updatePassword = (currentPassword, newPassword) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/users/update-password", {
        oldPassword: (0, md5_1.generateMD5Hash)(currentPassword),
        newPassword: (0, md5_1.generateMD5Hash)(newPassword),
    }, true);
});
exports.updatePassword = updatePassword;
